const svC = ['Noll', 'En', 'Två', 'Tre', 'Fyra', 'Fem', 'Sex', 'Sju', 'Åtta', 'Nio', 'Tio', 'Elva', 'Tolv'];
const svL = ['noll', 'en', 'två', 'tre', 'fyra', 'fem', 'sex', 'sju', 'åtta', 'nio', 'tio', 'elva', 'tolv'];
/** Returns "noll, ett, två" etc for numbers up to 12. Optional argument to capitalize. */
export const numberToTextSwe = (num: number, capitalize?: boolean): string => {
  if (num > 12 || num < 0) {
    return num.toString();
  }
  return capitalize ? svC[num] : svL[num];
};

const enC = ['Zero', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine', 'Ten', 'Eleven', 'Twelve'];
const enL = ['zero', 'one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight', 'nine', 'ten', 'eleven', 'twelve'];

/** Returns "zero, one, two" etc for numbers up to 12. Optional argument to capitalize. */
export const numberToTextEng = (num: number, capitalize?: boolean) => {
  if (num > 12 || num < 0) {
    return num.toString();
  }
  return capitalize ? enC[num] : enL[num];
};
